// Centralised brand + platform configuration (section 50).
export const BRAND = {
  name: "ELVORIA AI",
  wordmark: { primary: "ELVORIA", secondary: "AI" },
  tagline: "AI Automation & Business Operating Systems",
  message: "Your business, automated by AI.",
  support: "AI employees. One operating system. More leads. More appointments. Less repetitive work.",
  contactEmail: "rohit.bhattacharjee11@gmail.com",
  social: [
    { label: "LinkedIn", href: "#", note: "Profile coming soon" },
    { label: "X", href: "#", note: "Profile coming soon" },
    { label: "YouTube", href: "#", note: "Channel coming soon" },
  ],
  colors: { green: "#00FF66", cyan: "#00FFFF", base: "#05070A" },
  featureFlags: { demoMode: true, payments: false, voice: false, calendar: false, messaging: false },
};

export const PLANS = [
  {
    key: "starter",
    name: "STARTER",
    price: 499,
    setup: 999,
    summary: "Get the core operating system live: CRM, pipeline and an AI receptionist.",
    cta: "Book a Demo",
    ctaLink: "/book-demo",
    features: [
      "CRM",
      "Lead pipeline",
      "AI receptionist",
      "Calendar",
      "Basic automations",
      "Dashboard",
      "Email support",
    ],
  },
  {
    key: "growth",
    name: "GROWTH",
    price: 999,
    setup: 1999,
    highlight: true,
    summary: "Everything in Starter plus messaging, follow-up sequences, calendar sync and weekly AI reports.",
    cta: "Book a Demo",
    ctaLink: "/book-demo",
    features: [
      "Everything in Starter",
      "SMS automation",
      "WhatsApp automation",
      "Automated follow-up sequences",
      "Advanced workflows",
      "AI call insights",
      "Google Calendar synchronization",
      "Weekly AI business report",
      "Priority support",
    ],
  },
  {
    key: "scale",
    name: "SCALE",
    price: 1999,
    setup: 3999,
    summary: "Everything in Growth plus custom agents, multi-location support and white-glove onboarding.",
    cta: "Talk to Elvoria",
    ctaLink: "/contact",
    features: [
      "Everything in Growth",
      "Advanced / custom AI agents",
      "Custom automation workflows",
      "Multiple integrations",
      "Advanced analytics",
      "Multi-location / team support",
      "Dedicated onboarding",
      "Priority / white-glove support",
    ],
  },
];

export const PRICING_DISCLAIMER =
  "Third-party communication, AI, telephony and usage-based infrastructure costs may be billed separately depending on configuration and usage. Software and setup are fixed; provider usage is stated separately so you can forecast it.";

export const MODULES = [
  ["AI Receptionist", "Answers inbound calls, captures details and books appointments.", "Stop losing callers to voicemail.", "Phone"],
  ["AI Sales Agent", "Responds to enquiries and moves leads toward a booking.", "Reply in seconds, not hours.", "Bot"],
  ["AI Lead Qualification", "Scores and routes leads against your criteria.", "Your team works the right leads first.", "Filter"],
  ["CRM", "One record per customer with full history.", "No more leads lost in spreadsheets.", "Database"],
  ["Appointment Scheduling", "Availability, booking, reschedules and reminders.", "A diary that fills itself.", "CalendarCheck"],
  ["Automated Follow-Up", "Multi-step sequences until a reply.", "Consistent follow-up, every time.", "Repeat"],
  ["SMS", "Two-way text conversations from one inbox.", "Meet customers where they reply.", "MessageSquare"],
  ["WhatsApp", "WhatsApp threads alongside every other channel.", "One inbox for every channel.", "MessagesSquare"],
  ["Email Automation", "Confirmations, reminders and nurture email.", "Zero manual admin email.", "Mail"],
  ["Workflow Automation", "Trigger → condition → action workflows.", "Repetitive work runs itself.", "Workflow"],
  ["Customer Management", "Tags, notes, owners and lifecycle status.", "Full context before every conversation.", "Users"],
  ["Analytics", "Pipeline, calls, conversion and revenue reporting.", "See what actually drives revenue.", "BarChart3"],
  ["Payments", "Invoices, status tracking and payment reminders.", "Get paid without chasing.", "CreditCard"],
  ["Team Management", "Roles, permissions and assignment.", "Everyone knows who owns what.", "UserCog"],
  ["AI Reporting", "Written summaries of performance and gaps.", "Answers, not just dashboards.", "FileText"],
];

export const SERVICES = [
  ["ai-receptionists", "AI Receptionists", "Every call answered, qualified and logged."],
  ["ai-voice-agents", "AI Voice Agents", "Outbound and inbound voice agents with defined scopes."],
  ["crm-automation", "CRM Automation", "Records, stages and owners updated automatically."],
  ["lead-generation", "Lead Generation", "Capture forms, tracking and instant response."],
  ["appointment-automation", "Appointment Automation", "Availability, booking, reminders and rescheduling."],
  ["follow-up-automation", "Follow-Up Automation", "Sequences that continue until someone replies."],
  ["whatsapp-automation", "WhatsApp Automation", "Structured WhatsApp conversations at scale."],
  ["sms-automation", "SMS Automation", "Two-way SMS tied to CRM records."],
  ["email-automation", "Email Automation", "Transactional and nurture email workflows."],
  ["workflow-automation", "Workflow Automation", "Connect the systems your team already uses."],
  ["custom-ai-agents", "Custom AI Agents", "Agents scoped to your processes and tools."],
  ["business-dashboards", "Business Dashboards", "One operational view of the whole business."],
  ["ai-reporting", "AI Reporting", "Plain-language summaries of what changed and why."],
];

export const JOURNEY = [
  "Lead Capture",
  "Qualification",
  "Conversation",
  "Appointment",
  "Follow-up",
  "Conversion",
  "Customer Management",
  "Retention",
];

export const PROBLEMS = [
  ["Missed calls", "Inbound demand arrives when nobody is free to answer."],
  ["Slow responses", "Leads pick whoever replies first — usually not you."],
  ["Leads lost in spreadsheets", "No owner, no next step, no visibility."],
  ["Manual appointment scheduling", "Back-and-forth messages to book a 30 minute slot."],
  ["No consistent follow-up", "Follow-up depends on who remembers."],
  ["Scattered communication", "Calls, SMS, WhatsApp and email in four places."],
  ["Staff wasting time", "Skilled people doing copy-paste admin."],
  ["Poor visibility", "No reliable answer to \"where is that lead?\""],
  ["No central customer history", "Every conversation starts from zero."],
  ["No automation", "Every step needs a human to push it forward."],
  ["No meaningful analytics", "Reports that describe activity, not outcomes."],
];
